import { render, staticRenderFns } from "./editKeyword.vue?vue&type=template&id=12f6ad1c&scoped=true"
import script from "./editKeyword.vue?vue&type=script&lang=js"
export * from "./editKeyword.vue?vue&type=script&lang=js"
import style0 from "./editKeyword.vue?vue&type=style&index=0&id=12f6ad1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f6ad1c",
  null
  
)

export default component.exports